
import Transformer from './../transformer'

export default class AttendanceTransformer extends Transformer {
	static send({workPlanReal, assistanceList}) {
		return {
			work_plan_real: workPlanReal,
			assistance_list: assistanceList
		}
	}
}



// WEBPACK FOOTER //
// ./src/transformers/workPlan/attendance.js